/*
 * 戒导航 · 戒打卡模块（jiedh/checkin）—— 每日打卡提醒通知卡片
 *
 * 设计依据：doc/戒打卡功能设计方案.md §19.5。
 *
 * 职责：定时命令 flarum:checkin-remind 每天在设定时点，向「今日尚未打卡」的目标所有者
 *   发送一条站内提醒；本组件负责把它渲染到通知列表。
 *
 * 幂等：同一天只发一次由后端 NotificationSyncer + blueprint data 含 date 保证（§19.5），
 *   前端无需去重。
 *
 * ⚠️ 字段契约：下方 ReminderContent 的字段名必须与
 *   JieDH\Checkin\Notify\CheckinReminderBlueprint::getData() 保持一致。
 *
 * 范式参考：packages/review/js/src/forum/components/ModerationReceiptNotification.tsx。
 */
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * 通知数据契约（= CheckinReminderBlueprint::getData() 的返回值）。
 */

export default class CheckinReminderNotification extends Notification {
  /** 通知正文：「别忘了打卡：{habitName}」。 */
  content() {
    const {
      habitName
    } = this.data();
    return app.translator.trans('jiedh-checkin.forum.notifications.reminder_text', {
      habitName
    });
  }

  /** 左侧类型图标：铃铛。 */
  icon() {
    return 'fas fa-bell';
  }

  /** 点击跳转到独立页 /checkin，方便一键打卡。 */
  href() {
    const base = app.forum.attribute('baseUrl') || '';
    return `${base}/checkin`;
  }

  /** 副标题：已连续 N 天，别断。 */
  excerpt() {
    const {
      streak
    } = this.data();
    if (!streak) return '';
    return m("div", null, app.translator.trans('jiedh-checkin.forum.notifications.reminder_excerpt', {
      streak
    }));
  }

  /**
   * 读取通知携带的数据（防御：后端数据结构异常时不抛错、不白屏）。
   */
  data() {
    const content = this.attrs.notification.content() || {};
    return {
      habitName: String(content.habitName || ''),
      date: String(content.date || ''),
      streak: Number(content.streak || 0)
    };
  }
}
flarum.reg.add('jiedh-checkin', 'forum/components/CheckinReminderNotification', CheckinReminderNotification);